import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';

import store from '../store/store';
import Main from './Main';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Main />
    </Provider>
  </React.StrictMode>
);
